import NoveltyConfig from "./NoveltyConfig";
import AuthService from "../auth/AuthService"
export default class NoveltyService {
  /******* PLACES **********/
  static getNews(app) {
    
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = NoveltyConfig.endpointNews;
        let response = await NoveltyConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveNovelty(app,novelty) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = NoveltyConfig.endpointSaveNovelty;
        let response = await NoveltyConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify(novelty)
        });
        // console.log("RESPONSE SAVE PLACE",response)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deleteNovelty(app,noveltyId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = NoveltyConfig.endpointDeleteNovelty;
        let response = await NoveltyConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({id:noveltyId})
        });
        // console.log("RESPONSE DELETE Novelty",response, noveltyId)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  /******** FIN PLACES *********/
}


// WEBPACK FOOTER //
// ./src/provider/novelty/NoveltyService.js